var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_755_23082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7536 17.7229L13.2945 10.2884C14.0585 8.37251 13.6642 6.1127 12.1116 4.55703C10.2222 2.67386 7.28128 2.50192 5.18651 4.02483L8.34099 7.1771L7.17449 8.33157L4.02822 5.19567C2.50027 7.27535 2.67278 10.2147 4.56218 12.0897C6.09014 13.6126 8.31635 14.0138 10.2222 13.3015L17.7059 20.7605C18.0262 21.0798 18.5438 21.0798 18.8642 20.7605L20.7536 18.8773C21.0821 18.5662 21.0821 18.0504 20.7536 17.7229ZM18.2891 19.0329L10.5179 11.2873C10.0168 11.6558 9.45821 11.8768 8.87495 11.9587C7.75774 12.1225 6.58303 11.7868 5.72869 10.9353C4.94828 10.1656 4.58683 9.13396 4.64433 8.11869L7.18271 10.6487L10.6658 7.1771L8.12741 4.6471C9.14604 4.58978 10.1729 4.95004 10.9533 5.71969C11.8405 6.60396 12.1773 7.82393 11.9719 8.96202C11.8734 9.54335 11.6269 10.0837 11.249 10.5668L19.012 18.3042L18.2891 19.0329Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_755_23082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon);
export default __webpack_public_path__ + "static/media/service-icon.20fd91b67a897af49b25c4717d262b1a.svg";
export { ForwardRef as ReactComponent };